<!--
 * @Author: your name
 * @Date: 2020-08-27 10:37:46
 * @LastEditTime: 2024-07-31 17:44:31
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares\src\components\system\NodeManage.vue
-->
<template>
  <div class="node-manage">
    <enfold>
      <enfold-uc>
        <template slot="up">
          <div class="c-u-left">
            <img class="icon" src="@/assets/images/public/public_add.png" @click="addNode({id: 0, level: 0})" alt />
          </div>
          <div class="c-u-right"></div>
        </template>
        <div slot="center" v-loading="loading" style="padding: 0px 12px;">
          <div class="node-content-one" v-for="(oneItem,oneIndex) in authorityList" :key="oneIndex">
            <div v-if="oneItem.title !== '测试'">
              <div style="display: flex; align-items: center; height: 50px;">
                <el-tag closable @close="delNode(oneItem)">{{oneItem.title}}</el-tag>
                <i class="el-icon-plus" style="color: #2fb3ff; font-size: 22px; margin-left: 10px;" @click.stop="addNode(oneItem)"></i>
              </div>
              <div class="node-content-two">
                <!-- 折叠面板 -->
                <el-collapse v-model="activeNames" @change="handleChange">
                  <el-collapse-item :title="twoItem.title" v-for="(twoItem,twoIndex) in oneItem.child" :name="twoIndex" :key="twoIndex">
                    <template slot="title">
                      <el-tag closable @close="delNode(twoItem)">{{twoItem.title}}</el-tag>
                      <i class="el-icon-plus" style="color: #2fb3ff; font-size: 22px; margin-left: 10px;" @click.stop="addNode(twoItem)"></i>
                    </template>
                    <div class="node-content-three">
                      <el-tag v-for="(threeItem,threeIndex) in twoItem.child" :key="threeIndex" closable type="success" @close="delNode(threeItem)">{{threeItem.title}}</el-tag>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </div>
        </div>
      </enfold-uc>
    </enfold>
    <form-dialog :dialogVisible="FormDialogVisible" @closeDialog="FormCloseDialog" :title="$t('system.addNode')" dWidth="400px">
      <div class="form-dialog">
        <el-form :model="nodeForm" :rules="rules" ref="nodeForm" label-width="120px">
          <el-form-item :label="$t('system.EnglishName')" prop="name">
            <el-input v-model="nodeForm.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('system.ChineseName')" prop="title">
            <el-input v-model="nodeForm.title"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('nodeForm')" round>{{$t('basics.Cancel')}}</el-button>
            <el-button type="primary" @click="submitForm('nodeForm')" round>{{$t('basics.Confirm')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="DelCloseDialog" :title="$t('system.DeleteUser')">
      <div class="dd-dialog">{{$t('system.delNode')}}</div>
    </del-dialog>
  </div>
</template>

<script>
import enfold from '@/components/basics/Enfold'
import EnfoldUc from '@/components/basics/EnfoldUC'
import DelDialog from '@/components/basics/DelDialog'
import FormDialog from '@/components/basics/FormDialog'

export default {
  name: "NodeManage",
  data() {
    return {
      FormDialogVisible: false,
      DelDialogVisible: false,
      authorityList: [],
      activeNames: [],
      nodeTag: {},
      loading: true,
      nodeForm: {
        name: "",
        title: ""
      },
      rules: {
        name: [
          { required: true, message: this.$t('csn2'), trigger: 'blur' }
        ],
        title: [
          { required: true, message: this.$t('csn3'), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getNodeList()
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    FormCloseDialog() {
      this.FormDialogVisible = false;
    },
    DelCloseDialog(isConfirm = false) {
      console.log(isConfirm);
      if (isConfirm) {
        this.$http.post("/admin/access/delNode", { id: this.nodeTag.id }, data => {
          console.log(data);
          this.getNodeList()
          this.DelDialogVisible = false;
        });
      }
    },
    resetForm(nodeForm) {
      this.$refs[nodeForm].resetFields();
      this.FormDialogVisible = false;
    },
    submitForm(nodeForm) {
      this.$refs[nodeForm].validate((valid) => {
        if (valid) {
          let nadeData = {
            name: this.nodeForm.name,
            title: this.nodeForm.title,
            pid: this.nodeTag.id,
            level: parseInt(this.nodeTag.level) + 1
          }
          this.$http.post("/admin/access/addNode", nadeData, data => {
            console.log(data);
            this.getNodeList();
            this.$refs[nodeForm].resetFields();
            this.FormDialogVisible = false;
          });
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    addNode(tag) {
      console.log(tag);
      this.nodeTag = tag;
      this.FormDialogVisible = true;
    },
    delNode(tag) {
      console.log(tag);
      this.nodeTag = tag;
      this.DelDialogVisible = true;
    },
    getNodeList() {
      this.authorityList = [];
      this.$http.post("/admin/access/nodeList", {}, data => {
        this.authorityList = data;
        console.log(this.authorityList);
        this.loading = false;
      });
    }
  },
  components: {
    enfold,
    DelDialog,
    FormDialog,
    EnfoldUc
  }
}
</script>

<style lang="scss" scoped>
.node-manage {
  width: 100%;
  height: 100%;
  .node-content-one {
    .el-checkbox--medium {
      padding: 9px 20px 7px 0px;
      border: #fff;
    }
    .node-content-two {
      padding-left: 22px;
      .node-content-three {
        border-top: 1px solid #ebeef5;
        .el-tag {
          margin-top: 10px;
          margin-left: 10px;
        }
        .el-checkbox--small {
          padding: 7px 15px 5px 10px;
          border: 1px solid #dcdfe6;
        }
        .el-checkbox {
          display: inline-block;
          margin: 4px 4px 0px 0px;
        }
      }
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 25px;
  }
  // .dd-dialog {
  //   font-size: 16px;
  //   padding: 40px 0px;
  //   text-align: center;
  // }
  ::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    background: #a7d0ff;
    border-radius: 2px;
  }
  .icon {
    width: 30px;
  }
}
</style>